import React, {Component} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class TitleOrderHeader extends Component{
  constructor(props){
    super(props);
    this.state = {
        orderStatus : null,
        title : this.props.title,
        orderId : this.props.orderId,
        patientName: this.props.patientName
    }
  }

  render(){
    return(
      <div className="header-sample">
            <Container>
                <Row className="p-b-10 p-t-10">
                    <Col xs={12} md={12}  className="text-align-left margin-auto">
                        <div className="font-size-lg bold">
                          {this.state.title}
                        </div>
                    </Col>
          </Row>
          {this.state.orderId ? 
                 <Row>
                    <Col xs={6} md={6} className="text-align-left">
                        <div  className="font-size-sm">
                          ORDER ID
                        </div>
                        <div  className="font-size-smd bold">
                        {this.state.orderId}
                            {/* {this.state.headerDetails.orderId} */}
                        </div>
                    </Col>
                    <Col xs={6} md={6}  className="text-align-right">
                        <div  className="font-size-sm">
                          NAME
                        </div>
                        <div  className="font-size-smd bold">
                        {this.state.patientName}
                          {/* {this.state.headerDetails.patientDetails ? this.state.headerDetails.patientDetails[0].name : ''}  */}
                        </div>
                    </Col>
            </Row>
            : ''}
             </Container>
        </div>
    )
    }
}
export default TitleOrderHeader;